var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 0.507812L1 3.84115M23 3.84115L19.7 0.507812M5.4 18.2856L3.2 20.5078M18.6 18.2856L20.8 20.5078M8.7 12.1745L10.9 14.3967L15.85 9.3967M12 20.5078C14.3339 20.5078 16.5722 19.5713 18.2225 17.9043C19.8729 16.2373 20.8 13.9764 20.8 11.6189C20.8 9.26144 19.8729 7.00052 18.2225 5.33353C16.5722 3.66654 14.3339 2.73003 12 2.73003C9.66609 2.73003 7.42778 3.66654 5.77746 5.33353C4.12714 7.00052 3.2 9.26144 3.2 11.6189C3.2 13.9764 4.12714 16.2373 5.77746 17.9043C7.42778 19.5713 9.66609 20.5078 12 20.5078Z",
    stroke: "#00901E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenClock);
export default __webpack_public_path__ + "static/media/greenClock.13bb47c7b1e9be314c07fcf8cb0df380.svg";
export { ForwardRef as ReactComponent };